import { render, staticRenderFns } from "./assetsMaterial.vue?vue&type=template&id=944e5fee&scoped=true"
import script from "./assetsMaterial.vue?vue&type=script&lang=js"
export * from "./assetsMaterial.vue?vue&type=script&lang=js"
import style0 from "./assetsMaterial.vue?vue&type=style&index=0&id=944e5fee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944e5fee",
  null
  
)

export default component.exports